<template>
  <PopoverRoot>
    <PopoverTrigger as-child>
      <button
        type="button"
        aria-label="Show information"
        class="ml-0.5 inline-grid size-5 shrink-0 place-items-center rounded-full text-muted-foreground outline-2 outline-blue-500 transition hover:bg-card focus-visible:outline"
      >
        <InfoIcon class="size-3" />
      </button>
    </PopoverTrigger>

    <PopoverPortal>
      <PopoverContent
        align="center"
        :side-offset="8"
        :collision-padding="10"
        hide-when-detached
        class="z-popover overflow-hidden rounded-md border border-border bg-background px-3 py-2.5 text-[0.8125rem] leading-5 shadow-xl"
        :class="[$style.popover]"
      >
        <slot></slot>
      </PopoverContent>
    </PopoverPortal>
  </PopoverRoot>
</template>

<script setup lang="ts">
import {
  PopoverContent,
  PopoverPortal,
  PopoverRoot,
  PopoverTrigger,
} from "reka-ui";

import InfoIcon from "@/icons/heroicons/information-circle-micro.svg";
</script>

<style module>
.popover {
  transform-origin: var(--reka-popover-content-transform-origin);
  width: 300px;

  @media (prefers-reduced-motion: no-preference) {
    &[data-state="open"] :global {
      animation: pop-in 250ms var(--motion-timing-ease);
    }
    &[data-state="closed"] :global {
      animation: pop-out 250ms var(--motion-timing-ease);
    }
  }
}
</style>
